





















import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  name: 'TitleBar'
})
export default class TitleBar extends Vue {
  @Prop({
    type: Array,
    default: () => []
  })
  titleStack;
}
